module.exports = __webpack_public_path__ + "static/media/s.1bb82dce.png";